// Validate if the file has a valid video extension
export const validVideoFormat =(fileName) => {
  const availableFormats = [ 'MOV' ,'MP4', 'WEBM', 'AVI', 'WMV', 'MKV'];
  // Get the extension and remove the dot in the string
  const extension = (fileName.match(/\.[0-9a-z]+$/i)[0]).replace(/\./g, '');

  return availableFormats.includes(extension.toUpperCase());
}

// Validate if the file has a valid image extension
export const validImageFormat =(fileName) => {
  const availableFormats = ['JPG', 'JPEG' ,'BMP', 'PNG'];
  // Get the extension and remove the dot in the string
  const extension = (fileName.match(/\.[0-9a-z]+$/i)[0]).replace(/\./g, '');

  return availableFormats.includes(extension.toUpperCase());
}



// WEBPACK FOOTER //
// ./src/common/utils/formatValidation.js